import styled from 'styled-components'

export const Div = styled.section `
  width: 100%;
  background-color: ${props =>  props.backgroundColor || props.theme.sectionBgColorPrimary};
  margin-bottom: ${props => props.marginBottom};
`;
